const heatTransferFaq = [
  {
    question: "What is heat transfer?",
    answer:
      "Heat transfer is a printing method where a design is applied to a substrate, such as fabric, using heat and pressure. The design is typically printed onto a special transfer paper and then heat-pressed onto the material, creating a vibrant and durable image.",
  },
  {
    question: "What types of materials are suitable for heat transfer?",
    answer:
      "Heat transfer is versatile and can be applied to various materials, including cotton, polyester, blends, and more. It's commonly used for customizing apparel like T-shirts, sportswear, and promotional items like bags and hats.",
  },
  {
    question: "How does heat transfer differ from other printing methods?",
    answer:
      "Unlike traditional printing methods, heat transfer allows for full-color, detailed designs without the need for multiple screens or plates. It's a cost-effective solution for small to medium-sized orders and offers the flexibility to produce intricate designs with vibrant colors.",
  },
  {
    question: "Is heat transfer suitable for complex or detailed designs?",
    answer:
      "Yes, heat transfer is well-suited for complex and detailed designs, including photographs and multicolor images. The process allows for high-resolution printing, ensuring that intricate details are accurately transferred onto the material with precision.",
  },
  {
    question: "What is the durability of heat transfer prints?",
    answer:
      "Heat transfer prints are known for their durability, especially when applied correctly. The prints are resistant to fading, cracking, and peeling with proper care. Follow our care instructions to ensure the longevity of your heat transfer customized items.",
  },
];
export default heatTransferFaq;
